import { YPaymentAmount } from '../y/amount';
import { $api } from '../y/api';
import { YId, YTimeString } from '../y/types';

export interface CVideoPurchaseAdminView {
    id: YId;
    is_voided: boolean;
    is_test: boolean;
    user_id: YId;
    event_id: YId;
    producer_id: YId;
    video_id: YId;

    user_name: string;
    user_email: string;
    event_name: string;

    price: YPaymentAmount;

    created_at: YTimeString;
}

let purchases_admin_view_promise: Promise<CVideoPurchaseAdminView[]> | undefined;
export function cVideoPurchasesAdminView(reload?: boolean) {
    if(!purchases_admin_view_promise || reload) {
        purchases_admin_view_promise = $api.GET<CVideoPurchaseAdminView[]>('views/purchases/admin');
    }

    return purchases_admin_view_promise;
}

export function cVideoPurchaseRefund(id: YId) {
    return $api.POST<CVideoPurchaseAdminView>(`purchase/${id}/refund`);
}


